<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loading-text="Cargando..."
        class="elevation-1"
        :expanded.sync="expanded"
        show-expand
        item-key="id"
        :footer-props="footerOptions"
        single-expand
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-on:input="debounceInput"
              label="Buscar"
              single-line
              hide-details />
          </v-toolbar>
        </template>
        <template v-slot:item.tipo="{ item }">{{ deviceTypes[item.tipo] }}</template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-if="can('eliminar_dispositivo_empresa')"
                :color="themeColor"
                dark
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td
            v-if="item.servicio"
            :colspan="headers.length"
          >
            Servicio <b>{{ item.servicio }}</b> <br>
            <b>{{ item.cantidad }} folios</b> <br>
            Licencia: {{ item.codigo }}
            <v-col>
              <v-btn
                v-if="can('asociar_desasociar_dispositivo_empresa')"
                :color="themeColor"
                :disabled="!desassignable"
                @click="desassignLicence(item)"
              >
                Desasociar
              </v-btn>
            </v-col>
          </td>
          <td
            v-else
            :colspan="headers.length"
          >
            <v-row>
              <v-col>
                No hay licencias asignadas.
              </v-col>
            </v-row>
            <v-row v-if="can('asociar_desasociar_dispositivo_empresa')">
              <v-col>
                <v-select
                  v-model="selectedService"
                  :items="services"
                  label="Servicios"
                  item-value="licence_id"
                  @change="checkService(item)"
                >
                  <template v-slot:selection="data">
                    Servicio: {{ data.item.nombre }} - {{ data.item.codigo }} ({{ data.item.cantidad }} folios - {{ data.item.tiempo }} meses)
                  </template>
                  <template v-slot:item="data">
                    Servicio: {{ data.item.nombre }} - {{ data.item.codigo }} ({{ data.item.cantidad }} folios - {{ data.item.tiempo }} meses)
                  </template>
                </v-select>

              </v-col>
              <v-col>
                <v-btn
                  :color="themeColor"
                  :disabled="!assignable"
                  @click="assignLicence(item)"
                >
                  Asignar
                </v-btn>
              </v-col>
            </v-row>
          </td>
        </template>
        <template v-slot:footer>
          <v-row v-if="!showAdd" class="mx-2" justify="space-around">
            <v-col>
              <v-btn
                v-if="can('agregar_dispositivo_empresa')"
                :loading="loadDevices"
                :color="themeColor"
                class="white--text"
                @click="showDevices()"
              >Agregar Dispositivo</v-btn>
            </v-col>
          </v-row>
          <v-row class="mx-2" justify="center" v-else>
            <v-col cols="4">
              <v-select
                v-model="device"
                :items="devicesList"
                item-value="id"
                item-text="nombre"
                label="Dispositivo"
                required
              >
                <template
                  v-slot:selection="data"
                >{{ data.item.tipo }} - {{ data.item.nombre }} ({{data.item.serial}})</template>
                <template
                  v-slot:item="data"
                >{{ data.item.tipo }} - {{ data.item.nombre }} ({{data.item.serial}})</template>
              </v-select>
            </v-col>
            <v-col>
              <v-btn :color="themeColor" class="white--text" @click="assignDevice()">Asignar</v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
      <delete-dialog :message="message" :apiURL="apiURL" ref="delete" />
    </v-col>
    <v-dialog
        v-model="dialog"
        max-width="620"
      >
        <v-card>
          <v-card-title class="headline">
            ¿Estás seguro de que quieres eliminar este registro?
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="dialog = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="toggleStatusDelete"
              @click.prevent="deleteItem()"
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import * as _ from 'underscore';
import DeleteDialog from '~/components/Delete';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  props: {
    id: { default: '' },
    dealerId: { default: '' },
    action: { default: '' },
    queryParams: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    expanded: [],
    loading: false,
    editedIndex: -1,
    options: {},
    search: '',
    items: [],
    device: '',
    devicesList: [],
    deviceAmount: 1,
    showAdd: false,
    loadDevices: false,
    totalItems: 0,
    deviceTypes: ['DBox', 'Caja Registradora', 'Dispositivo Móvil'],
    footerOptions: { 'items-per-page-options': [10, 20, 30, 40, 50] },
    toggleStatus: false,
    message: '',
    selectedService: '',
    services: [],
    assignable: true,
    desassignable: true,
    name: '',
    dialog: false,
    toggleStatusDelete: false,
    headers: [
      {
        text: 'Nombre',
        value: 'nombre',
        sortable: true,
      },
      {
        text: 'Tipo',
        value: 'devices_type',
      },
      {
        text: 'Marca',
        value: 'marca',
      },
      {
        text: 'Modelo',
        value: 'modelo',
      },
      {
        text: 'Serial',
        value: 'serial',
      },
      {
        text: 'ID Dispositivo',
        value: 'id_dispositivo',
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/devices`;
    },
    apiURLDevice() {
      return '/api/catalogs/devices';
    },
    title() {
      return 'Dispositivos';
    },
    ...mapGetters({
      user: 'auth/user',
      dealer: 'profile/enterprise',
      themeColor: 'theme/themeColor',
    }),
  },
  components: {
    DeleteDialog,
  },

  watch: {
    options: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    search: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    apiURL: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
    queryParams: {
      handler() {
        this.refreshTable();
      },
      deep: true,
    },
  },

  mounted() {
    const url = `/api/enterprises/${this.id}/licence/showLicence`;
    window.axios.get(url)
    .then((response) => {
      this.services = response.data.items;
    });
    window.axios.get(`/api/enterprises/${this.id}`).then((result) => {
      this.name = result.data.name;
    });
  },

  methods: {
    debounceInput: _.debounce(function d(e) {
      this.search = e;
    }, 500),
    checkService(item) {
      if (item.tipo === 'DBox' && this.services.filter((service) => service.id === this.selectedService)[0].servicio !== 'PAC') {
        this.assignable = false;
      } else {
        this.assignable = true;
      }
    },
    showDevices() {
      // console.log('Dealer id: ' + this.dealerId, 'Id empresa: ' + this.id, this.dealer);
      this.dealerId = this.dealer.dealer_id;
      const url = this.dealerId ? `/api/catalogs/dealers/${this.dealerId}/available_devices`
        : `/api/enterprises/${this.id}/devices/available`;
      window.axios.get(url).then((result) => {
        this.showAdd = !this.showAdd;
        this.devicesList = result.data;
      });
    },
    assignDevice() {
      const data = {
        device: this.device,
        enterprise_id: this.id,
        type: 'E',
      };
      if (this.dealerId) {
        data.dealer = this.dealerId;
      }
      window.axios.post('/api/devices/associate', data)
      .then(() => {
        this.refreshTable();
        this.showAdd = !this.showAdd;
      });
    },
    refreshTable() {
      this.getDataFromApi().then((data) => {
        this.items = data.items;
        this.totalItems = data.total;
        this.loading = false;
      });
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise(async (resolve) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        const response = await this.getItems(
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        ).then((result) => {
          const data = result.data.items;
          const { total } = result.data;
          return { data, total } || [];
        });
        const items = response.data;
        const { total } = response;
        resolve({
          items,
          total,
        });
      });
    },
    getItems(page, itemsPerPage, sortBy, sortDesc) {
      const url = `${this.apiURL}?currentPage=${page}&perPage=${itemsPerPage}
        &search=${this.search}&sortBy=${sortBy}&desc=${sortDesc}${this.queryParams}`;
      const promise = window.axios.get(url).then();
      return promise;
    },
    openModalDelete(item) {
       this.dialog = true;
       this.item = item;
      },
    deleteItem() {
      this.getDataFromApi()
      .then((data) => {
        this.items = data.items;
      });
      this.toggleStatusDelete = true;
      const url = `${this.apiURLDevice}/${this.item.id}/${this.item.codigo}`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.toggleStatusDelete = false;
        this.dialog = false;
        this.getDataFromApi()
        .then((data) => {
          this.items = data.items;
          this.totalItems = data.total;
        });
      });
    },
    reset() {
      this.search = '';
    },
    assignLicence(item) {
      const data = {
        type: 'M',
        device_id: item.id,
        service: this.selectedService,
      };
      window.axios.post('/api/licences/associate', data)
      .then(() => {
        this.refreshTable();
      });
    },
    desassignLicence(item) {
      const data = {
        device_id: item.id,
      };
      window.axios.post(`/api/devices/dissociate/${item.id}`, data)
      .then(() => {
        this.refreshTable();
      });
    },
  },
};
</script>
